import axios from "axios";
import React, { useState, useEffect, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useFormik } from "formik";
import { toast } from "react-hot-toast";
import * as Yup from "yup";

const GraphicDesignerForm = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [initialDataLoaded, setInitialDataLoaded] = useState(false);

  // Initial values
  const getInitialValues = () => ({
    name: "",
    email: "",
    phone: "",
    company_name: "",
    website: "",
    gst_number: "",
    designation: "",
  });

  // Validation schema
  const validationSchema = Yup.object({
    name: Yup.string().required("Name is required"),
    email: Yup.string().email("Invalid email").required("Email is required"),
    phone: Yup.string().matches(/^[0-9]{10,15}$/, "Phone must be 10–15 digits"),
    company_name: Yup.string().required("Company name is required"),
    website: Yup.string(),
    gst_number: Yup.string(),
    designation: Yup.string().required("Designation is required"),
  });

  const formik = useFormik({
    initialValues: getInitialValues(),
    enableReinitialize: true,
    validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        try {
          setLoading(true);

          const response = await axios.post(
            `${process.env.REACT_APP_URL}/admin/graphic_designer`, // Changed to match update pattern
            values,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("Token")}`,
              },
            }
          );

          if (response.data.success) {
            toast.success("Graphic designer created successfully");
            navigate("/admin/graphic-designer");
            return response.data;
          }
        } catch (error) {
          console.error("Error creating graphic designer:", error);

          let errorMessage = "Failed to create designer";

          if (error.response?.data?.message) {
            errorMessage = error.response.data.message;
          }

          toast.error(errorMessage);
          throw error;
        } finally {
          setLoading(false);
        }
      } catch (error) {
        // Handle any additional error logic here
        console.error("Form submission error:", error);
      } finally {
        setSubmitting(false);
      }
    },
  });
  // Load initial data in edit mode
  // useEffect(() => {
  //   if (!initialDataLoaded) {
  //     const fetchDesigner = async () => {
  //       try {
  //         setLoading(true);
  //         const data = await getGraphicDesigner(id);
  //         formik.setValues(data);
  //         setInitialDataLoaded(true);
  //       } catch {
  //         navigate("/admin/graphic-designer");
  //       } finally {
  //         setLoading(false);
  //       }
  //     };
  //     fetchDesigner();
  //   }
  // }, [id, initialDataLoaded, getGraphicDesigner, navigate]);

  return (
    <div className="al">
      <div className="al-head">
        <div>
          <h1 className="al-title">Add New Graphic Designer</h1>
          <p className="al-sub">Register a new graphic designer with contact and company details.</p>
        </div>
        <div className="al-head__actions">
          <button type="button" className="al-btn" onClick={() => navigate(-1)} disabled={loading}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6" /></svg>
            Back
          </button>
        </div>
      </div>

      <form onSubmit={formik.handleSubmit}>
        <div className="al-card">
          <div className="al-cardhead">
            <div className="al-cardhead__icon"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></svg></div>
            <h3 className="al-cardhead__title">Designer Details</h3>
          </div>

          <div className="al-form">
            {Object.keys(formik.values).map((key) => (
              <div key={key}>
                <label className="al-label">
                  {key.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase())}
                </label>
                <input
                  type="text"
                  className="al-input"
                  name={key}
                  value={formik.values[key]}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched[key] && formik.errors[key] && (
                  <div className="al-err">{formik.errors[key]}</div>
                )}
              </div>
            ))}
          </div>

          <div className="al-actionbar">
            <button type="button" className="al-btn" onClick={() => navigate(-1)} disabled={loading}>Cancel</button>
            <button type="submit" className="al-btn al-btn--primary" disabled={loading}>
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round"><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></svg>
              {loading ? "Saving..." : "Save"}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default GraphicDesignerForm;
